//@ts-ignore
import ClientCaptcha from "react-client-captcha";
import clsx from "clsx";

import inputError from "../../assets/images/input_error.svg";
import { useState } from "react";
type Props = {
  validate: (res: boolean) => void;
  error?: any;
  isMobile?: boolean;
  submit?: () => void;
};

const Captcha = ({ error, validate, isMobile, submit }: Props) => {
  const [code, setCode] = useState();
  const [text, setText] = useState("");

  function handleValidate(val: string | number) {
    const res = `${val}` === `${code}`;
    setText(`${val}`);
    validate(res);
  }
  return (
    <div className="flex w-full flex-col">
      <span className="font-IRANSans font-normal text-sm text-[#33383D] mb-4">کد امنیتی</span>
      <div
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();

            submit && submit();
          }
        }}
        className={clsx("flex  gap-2  items-center flex-col-reverse  min-[955px]:flex-row ")}
      >
        <div className={"flex w-full flex-col"}>
          <div
            className={clsx(
              "flex  flex-row w-full min-h-[46px] border-2 rounded-md  px-3 py-1 items-center bg-white",
              error && "border-2 border-danger-1",
              !error && "border-[#C2D0E3] focus-within:border-blue-1"
            )}
          >
            <input
              type="number"
              maxLength={4}
              className="flex-1 items-center min-h-[38px] text-sm focus:outline-none text-gray-900 pr-2 placeholder:text-[#95A3B5]"
              onChange={(val) => handleValidate(val.target.value)}
            />
          </div>
        </div>
        <div className="min-h-[50px] flex items-center bg-gray-100 px-2 rounded-md w-full" dir="ltr">
          <ClientCaptcha
            captchaCode={(val: any) => {
              setCode(val);
              validate(text === val);
            }}
            chars={"123456789"}
            charsCount={4}
            containerClassName="flex flex-row-reverse justify-center "
          />
        </div>
      </div>
      {error && (
        <div className="flex flex-row items-center mt-2">
          <img src={inputError} alt="inputError" />
          <span className="text-right mt text-sm text-danger-1 mr-1 ">{error}</span>
        </div>
      )}
    </div>
  );
};

export default Captcha;
